import React from 'react'

import CheckBox from '../Forms/Checkbox/Checkbox'
import { Collapse } from '@material-ui/core'
const toggleCheckbox = props => {
  return (
    <div>
      <CheckBox
        checked={props.show}
        variant={props.variant}
        changed={props.changed}
        label={props.title}
      />
      <Collapse in={props.show}>{props.children}</Collapse>
    </div>
  )
}

export default toggleCheckbox
